import { Question } from 'generated-graphql/types';
import { sortQuestions } from './sortQuestions';

export const mapQuestionOrder = (questions: Question[] | undefined | null) => {
  if (!questions) {
    return [];
  }

  const newQuestions = [...questions];
  newQuestions.sort(sortQuestions);
  return newQuestions.map((question, index) => ({
    ...question,
    order: question.order ?? index
  }));
};
